import { useContext } from 'react';

import { TaskDetailContext } from './task-detail-context';

export const useCloseTaskDetail = () => {
  const { closeDetail } = useContext(TaskDetailContext);

  return closeDetail;
};
